module.exports = __webpack_public_path__ + "img/71b867f1cd00d390af812d0214add645.97911be9.png";